var exports = {
  "i": "xaee3c4fa--949a19--wrapper",
};

module.exports = exports;
